import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcRequirementStatusById,
    setCcRequirementStatusEdit,
    setCcRequirementStatusReloadEdit,
    initCcRequirementStatus,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface StatusEditProps {
    statusId: number
    editAccess: boolean
}

const Edit = ({
    statusId,
    editAccess,
}: StatusEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const status = useSelector((state: StoreType) => state.ccRequirementStatus.statusEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccRequirementStatus.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcRequirementStatusReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcRequirementStatusReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (statusId === 0) {
            dispatch(setCcRequirementStatusEdit(initCcRequirementStatus))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcRequirementStatusById(statusId, userData.accountId, project.id).then((res) => {
                dispatch(setCcRequirementStatusEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!status) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        status.id
                            ? (editAccess ? `${lang.editStatus} #${status.id}` : `${lang.viewStatus} #${status.id}`)
                            : lang.addStatus
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form status={status} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form status={status} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
